<template>
  <div class="page">
    <div class="page-container">
      <!--        网站首页-->
      <div class="page-tab">
        <img src="../assets/image/page/icon.png"/>
        <div @click="goHome()" class="page-tab-text">网站首页 >></div>
        <span>新闻动态</span>
      </div>
      <!--        文字标题部分-->
      <div class="page-content">
        <div class="page-title">思奇科技赋能中元保险互联网数字化营销新通路</div>
        <div class="page-time">
          <div class="page-line" style="margin-right: 20px"></div>
          2021-01-12 09:43
          <span>编辑：xql</span>
          <div class="page-line" style="margin-left: 20px"></div>
        </div>
      </div>
      <!--        文字内容部分-->
      <div class="page-product">
        <!--          第一部分-->
        <div class="page-one">
          <div class="page-text">
            后互联网时代,几乎所有行业都拥有技术基因,保险业也不例外;而在营销及客户体验领域,技术发展带来的变革巨大,使得营销早已进入到科技全面驱动的时代。与此同时,新冠疫情的爆发与持续,一方面使得互联网健康保险业务突飞猛进,另一方面也严重打击了保险业的传统营销模式;线上+线下的融合,早已势不可挡;科技赋能保险的互联网数字化营销,已然迫在眉睫。
          </div>
          <div class="page-text">
            天津思奇科技股份有限公司为国家高新技术企业,旨在为保险业、银行业等拥有大批C端用户的传统企业,提供金融科技全产业链综合服务。为客户提供系统规划、方案实施、部署运维、业务运营、用户管理与广告投放等形态多样的一站式金融科技服务,全面满足客户数字化转型的需求。
          </div>
          <div class="page-text">
            思奇科技携手旗下子公司极欧科技,根据中元保险客户资源特征,以“打造流畅的保险互联网营销新通路”为愿景,将中元保险的营销获客、销售、客户管理和持续销售分解为标准化流程,将互联网科技融入拆解后的各个环节,最终实现为客户提供最适合的保险营销产品与服务。
          </div>
          <div class="page-text">
            为中元保险企业建设数字生态的关键之一,在于保险业务与相关场景下非核心服务的结合,将保险销售、服务、理赔等更有效地融入到用户可接触的环境和整个保险数字生态圈之中,与用户之间形成高频互动,运用数字化渠道和技术,改造现有用户交互形式,让保险产品成为生态解决方案的一部分。
          </div>
          <div class="page-text">
            思奇科技深耕于保险科技创新领域,通过聚焦“智能语音+大数据”技术创新应用,打造智能数字营销项目,为客户提供一体化新型营销服务能力;通过科技覆盖小场景,结合场景的特殊性及保险产品的特性,以“线上+线下”相结合的个性化、定制化推广模式,将用户生活所需的服务和各类保险保障有机结合,实现精准营销。
          </div>
          <div class="page-text">
            新技术浪潮下,无论保险业将会发展至何方,客户行为加速线上化、产品形态创新化、运营模式数字化,都是当今时代保险公司面临的三大挑战。天津思奇科技股份有限公司通过多年积累深耕的行业信息化系统建设经验,致力于为客户率先构筑科技壁垒,全面满足客户数字化转型的需求,提供最适合的保险营销产品与服务。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageFour",
  methods: {
    goHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped lang="less">
.page {
  width: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;

  .page-container {
    margin-bottom: 60px;
    position: relative;
    margin-top: -150px;
    width: 60%;
    background: #FFFFFF;
    padding: 100px 60px 100px 60px;
    box-shadow: 0px 20px 73px 0px rgba(102, 153, 204, 0.2);

    .page-tab {
      padding-top: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;

      img {
        width: 15px;
        height: 20px;
        margin-right: 10px;
      }

      .page-tab-text {
        cursor: pointer;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
      }

      span {
        color: #2368DD;
        margin-left: 10px;
      }
    }

    .page-content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .page-title {
        padding-top: 100px;
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000000;
        opacity: 0.9;
      }

      .page-time {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 45px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;

        span {
          margin-left: 40px;
        }

        .page-line {
          width: 20%;
          height: 1px;
          background: #000000;
          opacity: 0.2;
        }
      }

    }
    .page-one {
      padding-top: 100px;
    }

    .page-product {
      display: flex;
      flex-direction: column;
      align-items: center;

      .page-img {
        margin-top: 50px;
      }

      .page-icon {
        padding-top: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #5A5A5A;

        span {
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color:#5A5A5A;
          line-height: 20px;
          opacity: 0.8;
        }
      }

      .page-text {
        margin-top: 20px;
        font-size: 14px;
        font-family: SourceHanSansCN-Normal;
        font-weight: 400;
        color: #808080;
        line-height: 28px;
        text-indent: 30px;
        opacity: 0.7;
      }

      .page-title {
        text-indent: 30px;
        margin-top: 25px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #5A5A5A;
        line-height: 26px;
        //opacity: 0.7;
      }

      .page-two-text {
        margin-top: 25px;
        line-height: 30px;
      }
    }
  }
}

@media (max-width: 1200px) {
  .page {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .page {
    .page-container {
      margin-top: -90px;
      padding: 50px 60px 100px 60px;

      .page-img {
        img {
          width: 260px;
          height: 144px;
        }
      }

      .page-content {
        .page-title {
          text-align: center;
          padding-top: 50px;
          font-size: 20px;
        }

        .page-time {
          .page-line {
            width: 0;
            height: 0;
          }
        }
      }
    }
  }
}

</style>
